import { useTranslation } from 'react-i18next';
import Badge from '../ui/Badge';
import { reviewTone } from '../../utils/documentReviewModel';

export interface ReviewDoc { review_state?: string | null; ote_signed_at?: string | null; updated_at?: string | null }

const dm = (v?: string | null): string => {
  if (!v) return '';
  const d = new Date(v);
  return Number.isFinite(d.getTime()) ? `${d.getDate()}.${d.getMonth() + 1}` : '';
};

/** FIX-D337 (D-337 §6) - the state of a document in the signature process, in the folders: "חתום: מנהל OTE 30.10 · הלקוח 31.10". */
export default function ReviewDocBadge({ doc }: { doc: ReviewDoc }) {
  const { t } = useTranslation();
  const state = doc.review_state || '';
  const who = [
    doc.ote_signed_at ? t('docReview.folder.ote', { date: dm(doc.ote_signed_at) }) : '',
    state === 'signed' ? t('docReview.folder.customer', { date: dm(doc.updated_at) }) : '',
  ].filter(Boolean).join(' · ');
  return (
    <Badge tone={reviewTone(state)} dot title={who ? t('docReview.folder.signed', { who }) : undefined}>
      {t(`docReview.state.${state}`)}
    </Badge>
  );
}
